var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/icon-button/icon-button.tsx";
const _excluded = ["src", "className", "iconClassName", "text", "transparent", "theme"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import classNames from 'classnames';
import React from 'react';
import SvgIcon from '../icon/svg-icon';
import Text from '../text/text';
/** A clickable icon. */
const IconButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      src,
      className,
      iconClassName,
      text,
      transparent = false,
      theme = 'seamless'
    } = props,
    filteredProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("button", _extends({
    ref: ref,
    type: "button",
    className: classNames('flex items-center gap-2 p-1 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 dark:ring-offset-0 focus:ring-primary-500', {
      'bg-white dark:bg-transparent': !transparent,
      'border border-solid bg-transparent border-gray-400 dark:border-gray-800 hover:border-primary-300 dark:hover:border-primary-700 focus:border-primary-500 text-gray-900 dark:text-gray-100 focus:ring-primary-500': theme === 'outlined',
      'opacity-50': filteredProps.disabled
    }, className)
  }, filteredProps, {
    "data-testid": "icon-button",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(SvgIcon, {
    src: src,
    className: iconClassName,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  }), text ? /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 9
    }
  }, text) : null);
});
export default IconButton;